import React from 'react'
import "../styles/app.css"

export interface SingleTab {
    id: number,
    name: string,
  } 

interface propTypes{
    tabs: Array<SingleTab>,
    selectedTab: SingleTab,
    onClick: (e:SingleTab) => void,
}

const TabsDS = ( props:propTypes ) => {

    const {tabs, selectedTab, onClick} = props

    return (
        <div className="tabs-wrap" data-test="tabs-wrap">
            <div className="tabs-header">
                <div className="tabs-list-wrap">
                    <ul className="tabs-list larger-02-height">
                        { tabs.map((item, index)=> {
                                const active = selectedTab.id === item.id ? "tabs-item-active" : ""
                                return (
                                    <li 
                                        className={`tabs-item ${active}`} 
                                        key={index}
                                        onClick={() => onClick(item)}>
                                        <span className="tabs-label">{item.name}</span>
                                    </li>
                                )
                            }) 
                        }
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default TabsDS
